import { Component, OnInit } from '@angular/core';

import { Data2Service } from './data2.service';
import { DateService } from './date.service';
import { InfoboxService } from './infobox/infobox.service';
import { QuestionService } from './question-dialog/question-dialog.service';

import { SimpleComponentComponent } from './simple-component/simple-component.component';

@Component({
	selector: 'app-simple',
	template: '',
})
export class SimpleComponent implements OnInit {
	loader = true;
	protected itemsBeforeDataLoad = 0;
	protected apiUrl = '';
	elements = [];
	data;
	tableRows = [];

	constructor(
		protected api: Data2Service,
		private readonly date: DateService,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
	) {}

	ngOnInit(): void {
		this.loadBefore();
	}

	protected loadBefore() {
		this.loadData();
	}

	protected loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/' + this.apiUrl + '/', (result, error) => {
			result.data = this.convertData(result.data);
			this.elements = result.data;
			this.loader = false;
		});
	}

	protected convertData(data) {
		return data;
	}

	protected resetData() {}

	showAdd() {
		this.resetData();
		new SimpleComponentComponent(this.question).dialogOpen();
	}

	submit() {
		if (this.data.id) {
			this.update();
			return;
		}
		this.add();
	}

	protected add() {
		this.api.post('/' + this.apiUrl + '/', this.data, (result, error) => {
			this.data.id = result.data;
			this.elements.push(this.data);
			new SimpleComponentComponent(this.question).dialogClose();
		});
	}

	protected update() {
		this.api.put('/' + this.apiUrl + '/' + this.data.id + '/', this.data, (result, error) => {
			let owner = this.elements.find((obj) => obj.id == this.data.id);
			owner = this.data;
			new SimpleComponentComponent(this.question).dialogClose();
		});
	}

	selectItem(data) {
		this.data = data;
		new SimpleComponentComponent(this.question).dialogOpen();
	}

	deleteReturn(result) {
		if (!result) {
			return;
		}
		this.api.del('/' + this.apiUrl + '/' + this.data.id, (result, error) => {
			if (error) {
				return;
			}
			this.elements = this.elements.filter((obj) => obj.id != this.data.id);
			this.data.id = null;
			this.infobox.success('Wykonano poprawnie');
		});
	}
}
